import React, { useState } from 'react'
import { ITableViewProps } from './type'
import { DataTable } from 'src/components/common/DataTable'
import { CustomPagination } from 'src/hook/usePagination'
import { Box, Typography } from 'src/components'
import { columns, data } from 'src/constants/Tabla'

export function AllTable(props: ITableViewProps) {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5) // Inicialmente, muestra 10 filas por página
    const { technologyView } = props

    const handlePageChange = (newPage: number) => {
        setPage(newPage)
    }

    const handleRowsPerPageChange = (event: { target: { value: any } }) => {
        const newRowsPerPage = event.target.value
        setRowsPerPage(newRowsPerPage)
        setPage(0) // Restablece la página a 0 cuando cambias el número de filas por página
    }
    return (
        <div>
            {technologyView === 'Contact Us' ? (
                <>
                    <Box marginBottom={4}>
                        <Typography
                            variant={'h1'}
                            fontSize={'large'}
                            fontWeight={600}
                        >
                            Contact Us
                        </Typography>
                    </Box>
                    <DataTable
                        columns={columns}
                        data={data.slice(
                            page * rowsPerPage,
                            (page + 1) * rowsPerPage
                        )}
                    />
                    <CustomPagination
                        handleChangePage={handleRowsPerPageChange}
                        rowsPerPageOptions={[5, 10, 15, 20]}
                        onPageChange={handlePageChange}
                        totalItems={data.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                    />
                </>
            ) : (
                <div>
                    <>
                        <Box marginBottom={4}>
                            <Typography
                                variant={'h1'}
                                fontSize={'large'}
                                fontWeight={600}
                            >
                                Suscribete
                            </Typography>
                        </Box>

                        <DataTable
                            columns={columns}
                            data={data.slice(
                                page * rowsPerPage,
                                (page + 1) * rowsPerPage
                            )}
                        />
                        <CustomPagination
                            handleChangePage={handleRowsPerPageChange}
                            rowsPerPageOptions={[5, 10, 15, 20]}
                            onPageChange={handlePageChange}
                            totalItems={data.length}
                            page={page}
                            rowsPerPage={rowsPerPage}
                        />
                    </>
                </div>
            )}
        </div>
    )
}
